import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../authentication/auth.service';
import { ACCESS_TOKEN_KEY } from 'src/app/shared/constants/auth_constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private authService: AuthService, private router: Router) { }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.isAuthorized(state);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Check if the user is authenticated
    const authToken = localStorage.getItem(ACCESS_TOKEN_KEY);

    if (authToken) {
      return true;
    } else {
      this.authService.navigateToLoginPage();
      return false;
    }
  }

  private isAuthorized(state: RouterStateSnapshot): boolean {
    // Pass the token key ('authToken') to getAuthToken
    if (!this.authService.canNavigateToDashboard()) {
      this.authService.visitedUrl = state.url;
      this.authService.navigateToLoginPage();
      return false;
    }

    return true;
  }

}
